// Utility functions for color manipulation and contrast calculation

export function getContrast(color1: string, color2: string) {
    var lum1 = luminance(hexToRGB(color1));
    var lum2 = luminance(hexToRGB(color2));
    var brightest = Math.max(lum1, lum2);
    var darkest = Math.min(lum1, lum2);
    return (brightest + 0.05) / (darkest + 0.05);
}

// Returns the average contrast multiple colors have to each other
export function getAverageContrast(colors: string[]) {
    if (colors.length < 2) {
        return 1
    }
    const contrasts: number[] = [];
    let sum = 0;
    for (let i = 0; i < colors.length - 1; i++) {
        for (let j = i + 1; j < colors.length; j++) {
            const contrast = getContrast(colors[i], colors[j]);
            contrasts.push(contrast);
            sum += contrast;
        }
    }
    return sum / contrasts.length;
}

export function luminance(color: ColorRGB) {
    const RED = 0.2126;
    const GREEN = 0.7152;
    const BLUE = 0.0722;

    const GAMMA = 2.4;
    var a = [color.r, color.g, color.b].map((v) => {
        v /= 255;
        return v <= 0.03928
            ? v / 12.92
            : Math.pow((v + 0.055) / 1.055, GAMMA);
    });
    return a[0] * RED + a[1] * GREEN + a[2] * BLUE;
}

interface ColorRGB {
    r: number,
    g: number,
    b: number
}

export function hexToRGB(hex: string): ColorRGB {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : { r: 0, g: 0, b: 0 };
}

/**
 * A linear interpolator for hexadecimal colors
 * @param {String} a
 * @param {String} b
 * @param {Number} amount
 * @example
 * // returns #7F7F7F
 * lerpColor('#000000', '#ffffff', 0.5)
 * @returns {String}
 */
export function lerpColor(a : any, b : any, amount : any) {

    var ah = parseInt(a.replace(/#/g, ''), 16),
        ar = ah >> 16, ag = ((ah >> 8) & 0xff), ab = ah & 0xff,
        bh = parseInt(b.replace(/#/g, ''), 16),
        br = bh >> 16, bg = ((bh >> 8) & 0xff), bb = bh & 0xff,
        rr = ar + amount * (br - ar),
        rg = ag + amount * (bg - ag),
        rb = ab + amount * (bb - ab);

    return '#' + (((1 << 24) + (rr << 16) + (rg << 8) + rb) | 0).toString(16).slice(1);
}